"use client"

import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';

// Interface atualizada que permite controlar quebras de linha
interface AnimatedTextProps extends HTMLMotionProps<"div"> {
  text: string;
  delay?: number;
  duration?: number;
  wordWrap?: boolean; // Novo: permitir controle sobre quebras de linha
}

const AnimatedText = ({ 
  text, 
  delay = 0, 
  duration = 0.05,
  className,
  wordWrap = false, // Por padrão, não quebrar palavras
  ...props 
}: AnimatedTextProps) => {
  // Dividir por palavras em vez de letras
  const words = text.split(' ');
  
  const container = {
    hidden: { opacity: 0 },
    visible: (i = 1) => ({
      opacity: 1,
      transition: { staggerChildren: duration * 2, delayChildren: delay * i }
    })
  };
  
  const child = {
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        damping: 12,
        stiffness: 200
      }
    },
    hidden: {
      opacity: 0,
      y: 20,
      transition: {
        type: "spring",
        damping: 12,
        stiffness: 200
      }
    }
  };
  
  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="visible"
      className={className}
      style={{ 
        whiteSpace: wordWrap ? 'normal' : 'pre-line', // Pre-line mantém quebras de linha
        display: 'block' // Garante que o container é um bloco
      }}
      {...props}
    >
      {words.map((word, index) => (
        <React.Fragment key={index}>
          <motion.span
            variants={child}
            style={{ 
              display: 'inline-block', // Cada palavra é um bloco inline
              whiteSpace: 'nowrap'     // Não quebra dentro de palavras
            }}
          >
            {word}
          </motion.span>
          {/* Adiciona espaço após cada palavra, exceto a última */}
          {index < words.length - 1 && (
            <span style={{ display: 'inline-block', whiteSpace: 'pre' }}>&nbsp;</span>
          )}
        </React.Fragment>
      ))}
    </motion.div>
  );
};

export default AnimatedText;